// initial state
const state = {
  top: 0
}

// getters
const getters = {
  getTop: state => state.top
}

// actions
const actions = {
  STEACTION ({commit}, data) {
    commit('SETTOP', data)
  }
}
// mutations
const mutations = {
  SETTOP: (state, item) => {
    state.top = item
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/head.js